import { UpdateServicesRequest } from 'src/js/model/api/request/update-services-request';
import { Service } from 'src/js/model/service';

export const createUpdateServicesRequest = (service: Service, value: boolean): UpdateServicesRequest => {
  const request: UpdateServicesRequest = {};
  request[service] = value ? 1 : 0;
  return request;
};
